import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { MatPaginator } from '@angular/material/paginator';
import { ConfirmComponent } from '../shared/dialogs/confirm/confirm.component';
import { Subscription } from 'rxjs';
import { KnowledgeDialogComponent } from './dialogs/knowledge-dialog/knowledge-dialog.component';
import { KnowledgeService } from '../services/knowledge.service';
import { KnowledgeBase } from '../models/knowledge-base';


@Component({
  selector: 'app-knowledge',
  templateUrl: './knowledge.component.html',
  styleUrls: ['./knowledge.component.scss'],
  entryComponents: [
    KnowledgeDialogComponent,
    ConfirmComponent
  ]
})
export class KnowledgeComponent implements OnInit {

  private sub: Subscription;
  public dataSource: MatTableDataSource<any>

  public displayedColumns: string[] = ['icon', 'name', 'edit', 'delete'];
  public displayedViewColumns: string[] = ['icon', 'name', 'edit'];

  constructor(
    public _knowledgeService: KnowledgeService,
    private dialog: MatDialog,
    private snackBar: SnackBarIconService) {

    this.sub = this._knowledgeService.select()
      .subscribe((result) => {

        let array = result.map(item => {

          let entity = new KnowledgeBase();
          entity.id = item.payload.doc.id;
          entity.name = item.payload.doc.data().name;
          entity.html = item.payload.doc.data().html;
          return entity;

        });

        this.dataSource = new MatTableDataSource(array);
        this.dataSource.paginator = this.paginator;
      },
        (error) => {
          console.log(JSON.stringify(error))
       //   this.snackBar.openSnackBar("Acesso negado", '', 'error');
        })
  }

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ngOnInit() {
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  openDialog(entity) {

    let data: KnowledgeBase = new KnowledgeBase();

    if (entity) {
      data = entity;
    } else {
      data = new KnowledgeBase();
    }

    this.dialog.open(KnowledgeDialogComponent, {
      width: '800px',
      height: '600px',
      panelClass: 'custom-dialog-container',
      data: data
    });

  }

  delete(entity) {

    let id = entity.id
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: entity.name + "<br><br>Excluir este Documento?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
        this._knowledgeService.delete(id)
          .then(
            () => {
              this.snackBar.openSnackBar("Sucesso!", '', 'success')
            }
          )
          .catch(
            (error) => { console.log("delete exam error: " + error.message) }
          )
          .finally(
            () => this.dialog.closeAll()
          )
      }

    })
    
  }

}


